<template>
  <v-container id="report" fluid grid-list-lg class="ma-0 pa-3">
    <v-card outlined>
      <v-card-title class="text-h6">Unduhan Lainnya</v-card-title>
      <v-card-subtitle class="pb-0">
        Laporan berbentuk halaman (RP 1, SIRS 6.3, IGD, Register Harian Rawat
        Jalan) ada di menu <strong>Laporan</strong> pada bilah kiri.
      </v-card-subtitle>
      <v-card-text>
        <v-btn
          v-if="showRegisterHF"
          class="mr-2 mb-2"
          color="primary"
          @click="downloadRegisterHF"
        >
          <v-icon left>mdi-download-outline</v-icon>
          Unduh Register HF
        </v-btn>
        <v-btn class="mb-2" color="primary" @click="showSkriningBatukDialog = true">
          <v-icon left>mdi-download-outline</v-icon>
          Unduh Skrining Batuk
        </v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showSkriningBatukDialog" persistent max-width="320">
      <v-card>
        <v-card-title>Unduk Skrining Batuk</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-menu
                v-model="showTglStartPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="tglStart"
                    label="Tgl Mulai"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tglStart"
                  @input="showTglStartPicker = false"
                  locale="id"
                  :max="maxStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12">
              <v-menu
                v-model="showTglEndPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="tglEnd"
                    label="Tgl Selesai"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="tglEnd"
                  @input="showTglEndPicker = false"
                  locale="id"
                  :max="maxStartDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="orange--text darken-1"
            text="text"
            @click.native="showSkriningBatukDialog = false"
          >
            Tutup
          </v-btn>
          <v-btn
            class="green--text darken-1"
            text="text"
            @click.native="downloadSkriningBatuk"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from "vue";
import { Component } from "vue-property-decorator";
import registerHf from "@/services/registerHf";
import { userModule } from "@/store/modules/user";
import Laporan from "@/services/Laporan";

@Component()
export default class Report extends Vue {
  showSkriningBatukDialog = false;
  showTglStartPicker = false;
  maxStartDate = new Date().toISOString().substr(0, 10);
  tglStart = new Date().toISOString().substr(0, 10);
  tglEnd = new Date().toISOString().substr(0, 10);
  // maxStartDate = new Date().toISOString().substr(0, 10);

  get showRegisterHF() {
    return userModule.user.unit_group_id == "27";
  }

  downloadRegisterHF() {
    registerHf.getReport();
  }

  downloadSkriningBatuk() {
    Laporan.getSkriningBatuk(
      this.tglStart,
      this.tglEnd,
      userModule.user.unit_group_id
    );
  }
}
</script>
